import {AggregationEnum, AggregationModel, GroupByDefinition, GroupByProjectionDefinition, GrouppedQueryModel, PredicateDefinition, RequestParams} from '@/libs/Api';
import {CrudEntity} from '@/libs/core/crud/crud-service';

export interface CrudQueryPredicate {
    field: string;
    op: string | number,
    comparand: string | number | Array<string> | Array<number> | CrudQueryPredicate[] | boolean | Date
    junction?: string | number
}

export interface CrudOrderBy<T> {
    field: keyof T,
    index?: number,
    order: 'asc' | 'desc'
}

export interface CrudQueryPaging {
    pageIndex: number;
    pageSize: number;
}

export interface CrudQueryModel<T> {
    predicates: CrudQueryPredicate[],
    orderby: CrudOrderBy<T>[]
}

export interface CrudDataQuery<T> {
    pageIndex: number,
    pageSize: number,

    data: CrudQueryModel<T>,
    params?: RequestParams,
    useCache?: boolean,
}

export function createCrudQueryPayload<T extends CrudEntity>(orderBy: CrudOrderBy<T> | CrudOrderBy<T>[] = [], predicates: CrudQueryPredicate[] = [], paging: CrudQueryPaging = {
    pageIndex: 1,
    pageSize: 999999
}, useCache = false, key = ""): { query: CrudDataQuery<T>, key: string } {
    return {
        query: {
            ...paging,
            data: {
                predicates: predicates,
                orderby: Array.isArray(orderBy) ? orderBy.map(mapOrderBy) : [mapOrderBy(orderBy)]
            },
            useCache,
        },
        key: key
    }
}

function mapOrderBy<T>(o: CrudOrderBy<T>) {
    return {
        field: o.field,
        index: o.index || 0,
        order: o.order
    }
}

export function createGroupedQueryPayload<T extends CrudEntity>(predicates: PredicateDefinition[] = [], groupBy: GroupByDefinition[] = [], projections: GroupByProjectionDefinition[] = [], key = ""): { query: GrouppedQueryModel, key: string } {
    return {
        query: {
            groupby: groupBy,
            projections: projections,
            predicates: predicates
        },
        key: key
    }
}

export function createAggregationQueryPayload(predicates: CrudQueryPredicate[] = [], aggregationPropertyName = "", key = ""): { query: AggregationModel, key: string } {
    return {
        query: {
            predicates: predicates,
            aggregation: AggregationEnum.Sum,
            aggregationProperty: aggregationPropertyName
        } as AggregationModel,
        key: key
    }
}
